import { render, staticRenderFns } from "./DealerDashboard.vue?vue&type=template&id=7672bc8c"
import script from "./DealerDashboard.vue?vue&type=script&lang=js"
export * from "./DealerDashboard.vue?vue&type=script&lang=js"
import style0 from "./DealerDashboard.vue?vue&type=style&index=0&id=7672bc8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports